export const initialState = {
  apiSuccessResponse: {
    create: false,
    update: false,
  },
  apiSuccess: '',
  apiSuccessMessage: '',
  apiErrorMessage: '',
  isStatusUpdated: false,
  loading: false,
  actionDate: new Date(),

  apiStatusData: [],

  entitlementId: 101,
  popupErrorMessage: '',

  //Data
  entitlementData: {
    billClassId: 0,
    billStartDate: '',
    entitlementId: 0,
    contractEndDate: '',
    currencyId: 0,
    description: '',
    entitlementTypeId: 0,
    erpSalesOrderId: 0,
    erpSalesOrderItemId: 0,
    firstModifiedTimestamp: '',
    firstModifiedUserId: 0,
    lastModifiedTimestamp: '',
    lastModifiedUserId: 0,
    hardEndDate: '',
    installBaseRefId: 0,
    lastAutoRenewDate: '',
    rentalFlag: '',
    shipDate: '',
    siteConfigFlag: '',
    tempAddFlag: '',
    warrantyId: 0,
    warrantyStatusId: 0,
    warrantyDuraction: 0,
    warrantyStartDate: '',
    warrantyFeeDeferral: 0,
    erpServiceProductId: 0,
    erpProductTypeId: 0,
    psProductCode: '',
    serviceProductName: '',
    serviceProductInfo: '',
    orderLineNum: 0,
    shipQty: 0,
    billClassName: '',
    initialUserName: '',
    orderImportDate: '',
    price: 0,
    warrantyInfo: '',
    warrantyPartNumber: 0,
    serialNumber: '',
    origSerialNumber: 0,
    entitlementTypeName: '',
    anniversaryMonth: '',
  },

  entitlementHistoryRecentData: [],

  entitlementHistoryData: null,
  entHisDataForValidation: null,
  entHisDataForVal_Loading: false,
  entitlementHistoryDataAddEdit: [],
  entitlementHistoryTotalCount: 0,
  entitlementHistoryLoading: false,

  isEntitlementHistoryEditModalOpen: false,
  isEntitlementHistoryAddModalOpen: false,
  entitlementHistoryStatus: [],
  entitlementServiceLevel: [],
  entitlementHistoryDetails: [],
  entitlementHistoryDetailsFound: false,
  isPriceClassFound: null,

  isEntitlementNoteResultsFound: false,
  entitlementNotesData: [],
  isNotesFound:false,
  entitlementNoteTotalCount: 0,
  loadingNotes:false,
  isAddNewNote: false,
  entitlementProductHistoryData: [],
  activeInactiveData: [],
  erpDisplayProduct: false,

  userId: 0,
  currencyId: 0,
  serviceLevelId: 0,
  annualFee: '',
  statusId: 0,
  comment: '',

  loadingTransfer: false,
  loadingActiveDeactive: false,
  activeInactiveDataStatus: [],

  transferEntitlementData: [],
  entitlementTransferDataData: [],
  entitlementTransferDataDataTotalCount: 0,
  entitlementTransferDataFound: false,
  entitlementTransferLoading:false,
  entitlementTrasferGridDisplay:false,

  isLoadingWarrantyData: false,
  entitlementWarrantyHistoryData: [],
  entitlementWarrantyHistoryDataTotalCount: 0,
  isEntitlementWarrantyHistoryDataFound: false,

  isLoadingSerialNumberData: false,
  entitlementSerialNumberHistoryData: [],
  entitlementSerialNumberHistoryTotalCount: 0,
  isEntitlementSerialNumberHistoryDataFound: false,

  getEntitlementSpecificWarrantyHistoryDetailsData: [],
  isEntitlementSpecificWarrantyHistoryDetailsDataFound: false,

  isCheckedWarrantyUpsert: null,
  popupLoadingWait: false,
  warrantyHistorySpecificDataStartDate: '',

  isStartDateValidated: null,
  startDateValidatedErrorMessage: '',

  showEditWarrantyModal: false,
  showAddWarrantyModal: false,
  errorMessagePopup: null,
  addWarrantyButtonClick: false,
  setingAddErrorMessage: null,
  transferGridRowData: [],
  currentSiteForTrnasfer: null,
  selectedSiteForShowData: null,
  warrantyFormData: {
    warrantyStartDate: '',
    warrantyDuration: '',
    warrantyFeeDefferal: 0,
    comment: '',
    entitlementId: 0,
    modifiedUserId: 0,
    modifiedTimestamp: '',
    warrantyTypeId: 3,
  },

  isEditMode: false,
  newWarrantyLoader: false,
  editWarrantyLoader: false,
  deleteWarrantyLoader: false,
  apiWarrentySuccessResponse: {
    create: false,
    update: false,
  },

  apiHistoryAddUpdateLoader: false,

  apiHistorySuccessResponse: {
    create: false,
    update: false,
  },

  apiHistoryTransferLoader: false,
  apiHistoryTransferSuccessResponse: {
    create: false,
    update: false,
  },

  trasferResult: [],
  historyTransferSiteLoader: false,
  historyTransferSiteData: [],

  historyTransferSiteActivityLoader: false,
  historyTransferSiteActivityData: [],
  redirectionSiteActivityFlag:false,
  noteCreateLocading: false,
  notRefreshEntOnTransfer: false,
  isSiteActivityFailed: false,
};
